/* ============================================================
   SORVEN — announcement bar rotation
   ------------------------------------------------------------
   Every message is already in the DOM; this only moves the
   is-on class between them. Nothing is created, fetched or
   measured, so the bar costs one interval per page.

   The rotation is deliberately not a setInterval left running
   forever. It is cleared and restarted around every manual
   move, so pressing an arrow gives you a fresh full interval to
   read what you just asked for rather than a stub of whatever
   was left on the clock.
   ============================================================ */
(function () {
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }

  function init(root) {
    if (root._svAnnBound) return;
    root._svAnnBound = true;

    var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-sv-announce-msg]'));
    if (msgs.length < 2) return;

    var prev = root.querySelector('[data-sv-announce-prev]');
    var next = root.querySelector('[data-sv-announce-next]');
    var wait = (Number(root.dataset.interval) || 5) * 1000;
    var i = 0;
    var timer = null;

    function show(n) {
      i = ((n % msgs.length) + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) {
        var on = k === i;
        m.classList.toggle('is-on', on);
        /* Hidden copies are stacked underneath the visible one, so they
           are taken out of the accessibility tree rather than left for a
           screen reader to read as four messages at once. */
        if (on) { m.removeAttribute('aria-hidden'); }
        else { m.setAttribute('aria-hidden', 'true'); }
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      stop();
      /* Content that moves on its own is content the customer did not ask
         to move. Under reduced motion it holds still and the arrows are
         the only way it advances. */
      if (reduced()) return;
      timer = setInterval(function () { show(i + 1); }, wait);
    }

    function step(dir) {
      show(i + dir);
      start();
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* Pause while it is being read or tabbed through. */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* A background tab still fires intervals; there is no point turning
       messages over for nobody, and it means the customer does not come
       back to a bar mid-transition. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if (mq && mq.addEventListener) mq.addEventListener('change', start);

    show(0);
    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-sv-announce]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }

  /* Theme editor re-renders the section on every settings change. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
